export function monitoringPackTarget({ section, page }) {
  const params = new URLSearchParams({ section: section === 'test' ? 'test' : 'amb' });
  if (Number.isInteger(page) && page > 1) params.set('page', String(page));
  return `/monitoring2?${params}`;
}
